import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DataTableModule } from "@bfx/primeng/datatable";
import { FieldsetModule } from "@bfx/primeng/fieldset";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TabViewModule } from "@bfx/primeng/tabview";
import { TooltipModule } from "@bfx/primeng/tooltip";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { BfxOrderDetailsComponent } from "./bfx-order-details.component";
import { BfxOrderDetailsCcySelectorComponent } from "./bfx-order-details-ccy-selector.component";
import { BfxOrderDetailsContextMenu } from "./bfx-order-details-contextmenu";
import { BfxGammaRungsPanelComponent } from "./bfx-gamma-rungs-panel.component";
import { BfxOrderDetailsContextMenuService } from "./bfx-order-details-contextmenu.service";
import { BfxBlotterOrdersModule } from "../bfx-blotter-orders/bfx-blotter-orders.module";
import { TranslateModule } from "@ngx-translate/core";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxTradeBlotterModule } from "../bfx-blotter-trade/bfx-trade-blotter.module";
import { AgGridModule } from "@bfx/ag-grid-angular";

import { FormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
//import { BfxBmarkClientOrdersBlotterModule } from '../bfx-bmark-summary/blotters/client-orders/bfx-bmark-client-orders-blotter.module';
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BmarkSummaryModule } from "../bfx-bmark-summary/bmark-summary.module";

import { GammaAmountRenderer } from "./renderers/GammaAmountRenderer";
import { BfxBlotterOrdersActionSubjectModule } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";
import { BfxAllocationBlotterService } from "app/bfx-order-details/services/bfx-allocations.service";
import { BfxAllocationsBlotterComponent } from "app/bfx-order-details/bfx-allocations-blotter.component";
import { CommonIntentRenderer } from "app/bfx-blotter-orders/renderers/CommonIntentRenderer";
// import { BfxTradeBlotterDetailsComponent } from '../bfx-blotter-trade/bfx-trade-blotter-details.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    TooltipModule,
    PerfectScrollbarModule,
    OverlayPanelModule,
    FieldsetModule,
    FlexLayoutModule,
    FormsModule,
    TabViewModule,
    TranslateModule,
    BfxSharedModule,
    BfxTradeBlotterModule,
    BfxBlotterOrdersModule,
    BmarkSummaryModule,
    DataTableModule,
    OverlayPanelModule,
    BfxElementsLibraryModule,
    NativeDesktopModule,
    AgGridModule.withComponents([CommonIntentRenderer]),
    BfxBlotterOrdersActionSubjectModule,
  ],
  declarations: [
    GammaAmountRenderer,
    BfxOrderDetailsComponent,
    BfxOrderDetailsContextMenu,
    BfxOrderDetailsCcySelectorComponent,
    BfxGammaRungsPanelComponent,
    BfxAllocationsBlotterComponent,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxOrderDetailsContextMenuService,
    BfxAllocationBlotterService,
  ],
  exports: [BfxOrderDetailsComponent, BfxAllocationsBlotterComponent],
  bootstrap: [BfxOrderDetailsComponent],
})
export class BfxOrderDetailsModule {}
